import { BrowserDetection } from '@inter-ikea-kompis/browser-support';
import SupportedBrowsers from './BrowserSupport/SupportedBrowsers.json';
import { ITranslations } from '@inter-ikea-kompis/types';

export default class BrowserSupport {
	/**
	 * Check if browser is supported and shows system message if it doesn't.
	 */
	public static checkSupport(translations: ITranslations): void {
		let isSupported: boolean;

		try {
			// One of the most popular browsers in China 'UC Browser' can not run our app properly.
			// So it is not in the SupportedBrowsers list.
			isSupported = !!BrowserDetection.hasSupport(SupportedBrowsers);
		} catch (error) {
			isSupported = false;
		}

		if (!isSupported) {
			const header = BrowserSupport.getErrorMessageHeader(translations);
			const text = BrowserSupport.getErrorMessageText(translations);

			const message = header + '.\n\n' + text;
			alert(message);
		}
	}

	/**
	 * Gets translated no browser support error message header.
	 */
	private static getErrorMessageHeader(translations: ITranslations): string {
		return translations.kompis.browserNotSupportedTitle;
	}

	/**
	 * Gets translated no browser support error message.
	 */
	private static getErrorMessageText(translations: ITranslations): string {
		return translations.kompis.browserNotSupportedText;
	}
}
